import React from "react";
import { makeStyles } from '@mui/styles';
import { qrReaderMaskLeftRightWidth, qrReaderMaskTopBottomHeight } from "../../../constants";
import colors from "../../../../../common/styles/colors";

const commonStyles: { [key: string]: React.CSSProperties } = {
  beforeCommonStyles: {
    width: 6,
    height: 20
  },
  afterCommonStyles: {
    width: 20,
    height: 6
  },
  dimensionsBeforeAfterCommonStyles: {
    position: "absolute",
    backgroundColor: "#fff",
    content: "''",
    zIndex: 2
  },
  dimensionsCommonStyles: {
    position: "relative",
    backgroundColor: "transparent",
    width: "49.8%",
    height: "49.6%"
  }
};

export default makeStyles({
  container: {
    margin: "auto",
    width: `calc(100% - ${qrReaderMaskLeftRightWidth} * 2 + 10px)`,
    height: `calc(100% - ${qrReaderMaskTopBottomHeight} * 2 + 10px)`,
    "@media screen and (max-width: 447px)": {
      width: "60vw"
    },
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    position: "relative",
    "&::after": {
      position: "absolute",
      content: "''",
      width: "99.53%",
      height: 5,
      backgroundColor: colors.pinkColor,
      zIndex: 1,
      left: 0,
      top: 20,
      animationName: "$scanner-motion",
      animationDuration: "5s",
      animationIterationCount: "infinite",
      animationTimingFunction: "linear"
    }
  },
  activeScannerTopLeft: {
    ...commonStyles.dimensionsCommonStyles,
    "&::before": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.beforeCommonStyles,
      top: 0,
      left: 0
    },
    "&::after": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.afterCommonStyles,
      top: 0,
      left: 0
    }
  },
  activeScannerTopRight: {
    ...commonStyles.dimensionsCommonStyles,
    "&::before": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.beforeCommonStyles,
      top: 0,
      right: 0
    },
    "&::after": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.afterCommonStyles,
      top: 0,
      right: 0
    }
  },
  activeScannerBottomLeft: {
    ...commonStyles.dimensionsCommonStyles,
    "&::before": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.beforeCommonStyles,
      bottom: 0,
      left: 0
    },
    "&::after": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.afterCommonStyles,
      bottom: 0,
      left: 0
    }
  },
  activeScannerBottomRight: {
    ...commonStyles.dimensionsCommonStyles,
    "&::before": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.beforeCommonStyles,

      bottom: 0,
      right: 0
    },
    "&::after": {
      ...commonStyles.dimensionsBeforeAfterCommonStyles,
      ...commonStyles.afterCommonStyles,
      bottom: 0,
      right: 0
    }
  },
  "@keyframes scanner-motion": {
    "0%": {
      top: 20
    },
    "50%": {
      top: "calc(100% - 25px)"
    },
    "100%": {
      top: 20
    }
  }
});
